import styled, { keyframes } from 'styled-components';

interface Props {
  progress: number;
}

export const CanvasLoadingProgress = ({ progress }: Props) => (
  <CanvasLoader>
    <ProgressTrack>
      <ProgressFill style={{ width: `${progress}%` }} />
    </ProgressTrack>
  </CanvasLoader>
);

const CanvasLoader = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const shimmer = keyframes`
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
`;

const ProgressTrack = styled.div`
  width: 250px;
  height: 4px;
  border-radius: 2px;
  overflow: hidden;
  background-color: var(--border-light);
`;

const ProgressFill = styled.div`
  height: 100%;
  border-radius: 2px;
  background: linear-gradient(
    90deg,
    var(--active-blue) 0%,
    #4d9fff 50%,
    var(--active-blue) 100%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;
  transition: width 0.3s ease-out;
`;
